import { render, staticRenderFns } from "./NotificationsMenuDrawer.vue?vue&type=template&id=55fcc972"
import script from "./NotificationsMenuDrawer.vue?vue&type=script&lang=js"
export * from "./NotificationsMenuDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports